import { render, staticRenderFns } from "./ts-widget.vue?vue&type=template&id=6d79f7b0"
import script from "./ts-widget.vue?vue&type=script&lang=js"
export * from "./ts-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports